export default __webpack_public_path__ + "static/media/end-to-end-handoff.600884c4.png";